import { createContext } from "react";
import { UIContextProps } from "../../@types/contexts/UIContext/UIContextProps.types";

const UIContext = createContext({} as UIContextProps);

export default UIContext;
